React = require 'react'
$ = require 'jquery'
Auth = require 'db/auth'
Util = require 'lib/util'
PopOver = require 'views/lib/pop-over'
t = require('views/internal/recup-with-helpers')('home')
HomeTab = require 'views/home/home-tab'
CreateOrgView = require 'views/organization/create-org-view'

module.exports = class HomeLeftSidebarContainer extends React.Component
  displayName: 'HomeLeftSidebarContainer'

  constructor: ->
    @onCreateTeamClick = @onCreateTeamClick.bind(@)

  onCreateTeamClick: (e) ->
    Util.preventDefault(e)

    { model, modelCache } = @props

    PopOver.toggle
      elem: $(e.target)
      view: CreateOrgView
      options: {
        model: model
        modelCache: modelCache
      }

  render: t.renderable ->
    { modelCache, orgname } = @props
    orgs = modelCache.get('Member', Auth.myId())?.getSortedOrgs()

    t.div '.home-left-sidebar-container', =>
      t.div '.home-tab-container', =>
        t.tag HomeTab, {
          key: 'home'
          url: "/"
          selected: !orgname
          name: 'home'
          iconClass: 'home'
        }

        orgs.map (org) =>
          name = org.get('name')
          displayName = org.get('displayName')
          logoHash = org.get('logoHash')

          t.tag HomeTab, {
            key: org.id
            url: "/#{name}/home"
            selected: name == orgname
            name: displayName
            logoHash
            iconClass: 'organization'
          }

        t.div '.home-tab', =>
          t.a '.home-tab-link', { onClick: @onCreateTeamClick, href: '#' }, ->
            t.span ".icon-sm.icon-add.home-tab-link-icon"
            t.span '.home-tab-link-text', ->
              t.format 'home-create-team'



// WEBPACK FOOTER //
// ./app/scripts/views/home/home-left-sidebar-container.coffee